import { inventoryLocationsTypes } from '@Actions/settings/inventoryLocationActions';

const InventoryLocationReducers = (state = { }, action) => {
  switch (action.type) {
  case inventoryLocationsTypes.GET_INVENTORY_LOCATIONS.LOADING: {
    const { getInventoryLocationsLoading } = action;
    return {
      ...state,
      getInventoryLocationsLoading,
    };
  }
  case inventoryLocationsTypes.GET_INVENTORY_LOCATIONS.SUCCESS: {
    const { inventoryLocations } = action;
    return {
      ...state,
      inventoryLocations,
    };
  }
  case inventoryLocationsTypes.CREATE_INVENTORY_LOCATION.LOADING: {
    const { createInventoryLocationLoading } = action;
    return {
      ...state,
      createInventoryLocationLoading,
    };
  }
  case inventoryLocationsTypes.UPDATE_INVENTORY_LOCATION.LOADING: {
    const { updateInventoryLocationLoading } = action;
    return {
      ...state,
      updateInventoryLocationLoading,
    };
  }
  case inventoryLocationsTypes.DELETE_INVENTORY_LOCATION.LOADING: {
    const { deleteInventoryLocationLoading } = action;
    return {
      ...state,
      deleteInventoryLocationLoading,
    };
  }
  default: {
    return state;
  }
  }
};

export default InventoryLocationReducers;
